module.exports = __webpack_public_path__ + "static/media/hostess-icon.ad80acf3.svg";